import PreProposalActionTypes from "./preproposals.types";

export const preProposalListStart = (data: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_ALL_START,
  payload: data,
});

export const preProsalListFailure = (failure: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_ALL_FAILURE,
  payload: failure,
});

export const preProsalListSuccess = (success: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_ALL_SUCCESS,
  payload: success,
});

export const preProsaslListReset = () => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_ALL_RESET_START,
});

export const preProsalListChanged = () => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_ALL_CHANGED,
});

//***********PREPROPOSALS LIST END*****************/

export const preProposalSearchStart = (data: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_START,
  payload: data,
});

export const preProsalSearchFailure = (failure: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_FAILURE,
  payload: failure,
});

export const preProsalSearchSuccess = (success: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_SUCCESS,
  payload: success,
});

export const preProsaslSearchReset = () => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_RESET_START,
});

export const preProsalSearchChanged = () => ({
  type: PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_CHANGED,
});

//***********PREPROPOSALS SEARCH END*****************/

//***********PREPROPOSALS PUSH TO DIAL START*****************/
export const preProposalPushToDialStart = (data: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_START,
  payload: data,
});

export const preProposalPushToDialSuccess = (success: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_SUCCESS,
  payload: success,
});

export const preProposalPushToDialFailure = (failure: any) => ({
  type: PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_FAILURE,
  payload: failure,
});

export const preProposalPushToDialReset = () => ({
  type: PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_RESET,
});

//***********PREPROPOSALS PUSH TO DIAL END*****************/